import { httpRequest, request } from '../request';
import type { ApiParamsDefinition } from '../types/api-definition';
import type { IHomePageBlockResponse } from '../types/homePage';

// 定义 homeBlock 请求参数类型
interface HomeBlockParams {
  block_type?: string | number;
  status?: number;
}

const index = {
  // 首页block配置
  indexBlock: (data: any, config?: any) => request('/api/block/block', 'get', data, config), // 首页配置
  getBlockByUrlSuffix: (data: any, config?: any) =>
    request('/api/subject/getBlockByUrlSuffix', 'get', data, config), // 自定义专题页配置
  homePageBlock: (data: any) => request('/api/block/block_index', 'get', data), // 首页专用配置（在indexBlock基础上由后端做过字段过滤）
  homeBlock: (data: HomeBlockParams, config?: any): Promise<IHomePageBlockResponse> => {
    return httpRequest(
      'GET:/api/block/home_index',
      { params: data } as any,
      config,
    ) as unknown as Promise<IHomePageBlockResponse>;
  }, // 首页专用配置（在indexBlock基础上由后端做过字段过滤）

  // 评价接口
  trustpilot: (data: any) => request('/api/block/trustpilot', 'get', data), // 三方评价接口
  /** BFF 首页骨架（不含 goods 商品列表） */
  bffPcHome: (data: ApiParamsDefinition['GET:/api/bff/pc_home_lite']['params']) => {
    return httpRequest('GET:/api/bff/pc_home_lite', { params: data });
  },

  /** BFF 首页 goods 商品列表 */
  bffPcHomeProducts: (params: ApiParamsDefinition['GET:/api/bff/pc_home_products']['params']) =>
    httpRequest('GET:/api/bff/pc_home_products', {
      params,
    }),
  /** 首页爬虫 */
  homeSpider: () => httpRequest('GET:/api/bff/pc_home_spider'),
};
export default index;
